import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
/**
 * Enum representing the status of insurance.
 */
export let EInsuranceStatus;

/**
 * Interface representing the external ID for insurance.
 */
(function (EInsuranceStatus) {
  EInsuranceStatus["Archived"] = "archived";
  EInsuranceStatus["Active"] = "active";
  EInsuranceStatus["Draft"] = "draft";
  EInsuranceStatus["Inactive"] = "inactive";
  EInsuranceStatus["Cancelled"] = "cancelled";
  EInsuranceStatus["EnteredInError"] = "entered-in-error";
})(EInsuranceStatus || (EInsuranceStatus = {}));
/**
 * Enum for insurance verification status.
 */
export let EInsuranceVerificationStatus;

/**
 * Interface representing the last verification details for insurance.
 */
(function (EInsuranceVerificationStatus) {
  EInsuranceVerificationStatus["Unknown"] = "unknown";
  EInsuranceVerificationStatus["Unverified"] = "unverified";
  EInsuranceVerificationStatus["Active"] = "active";
  EInsuranceVerificationStatus["Inactive"] = "inactive";
  EInsuranceVerificationStatus["Failed"] = "failed";
  EInsuranceVerificationStatus["Eligible"] = "eligible";
  EInsuranceVerificationStatus["NotEligible"] = "not-eligible";
})(EInsuranceVerificationStatus || (EInsuranceVerificationStatus = {}));
/**
 * Interface representing the dependent's date of birth.
 */
/**
 * Interface representing the details of an insurance-dependent.
 */
/**
 * Enum representing the eligibility source.
 */
export let EEligibilitySource;

/**
 * Enum representing types of insurance changes.
 */
(function (EEligibilitySource) {
  EEligibilitySource["Database"] = "database";
  EEligibilitySource["RealTime"] = "realtime";
})(EEligibilitySource || (EEligibilitySource = {}));
export let EInsuranceChangeType;

/**
 * Enum representing the acknowledgement status of insurance.
 */
(function (EInsuranceChangeType) {
  EInsuranceChangeType["Updated"] = "updated";
  EInsuranceChangeType["Added"] = "added";
  EInsuranceChangeType["Deleted"] = "deleted";
  EInsuranceChangeType["EligibilityFailed"] = "eligibility-failed";
  EInsuranceChangeType["EligibilityInactive"] = "eligibility-inactive";
  EInsuranceChangeType["CopayUnknown"] = "copay-unknown";
})(EInsuranceChangeType || (EInsuranceChangeType = {}));
export let EInsuranceAcknowledgementStatus;

/**
 * Type representing an insurance acknowledgement.
 */
(function (EInsuranceAcknowledgementStatus) {
  EInsuranceAcknowledgementStatus["Acknowledged"] = "acknowledged";
  EInsuranceAcknowledgementStatus["Rejected"] = "rejected";
  EInsuranceAcknowledgementStatus["Approved"] = "approved";
})(EInsuranceAcknowledgementStatus || (EInsuranceAcknowledgementStatus = {}));
/**
 * Type representing an insurance change.
 */
/**
 * Type representing insurance information.
 */
export let EInsuranceEligibilityWizardStatus;
(function (EInsuranceEligibilityWizardStatus) {
  EInsuranceEligibilityWizardStatus["IN_PROGRESS"] = "in-progress";
  EInsuranceEligibilityWizardStatus["PENDING"] = "pending";
  EInsuranceEligibilityWizardStatus["SUCCESS"] = "success";
  EInsuranceEligibilityWizardStatus["FAILURE"] = "failure";
})(EInsuranceEligibilityWizardStatus || (EInsuranceEligibilityWizardStatus = {}));
/**
 * Interface representing insurance details.
 */
/**
 * Fields and their types for the insurance model.
 */
export const fieldsInsurance = _extends({}, fieldsIBaseModelWithUser, {
  active: {
    type: 'Boolean'
  },
  dependent: {
    type: 'Object'
  },
  endDate: {
    type: 'Date'
  },
  externalId: {
    type: 'Object'
  },
  fileUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  fileUploadBack: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  firstname: {
    type: 'Text'
  },
  insuranceGroupName: {
    type: 'Text'
  },
  lastname: {
    type: 'Text'
  },
  memberName: {
    type: 'Text'
  },
  memberNumber: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  payerId: {
    type: 'Text'
  },
  payerName: {
    type: 'Text'
  },
  payor: {
    type: 'Text'
  },
  planName: {
    type: 'Text'
  },
  primary: {
    type: 'Boolean'
  },
  relationshipToSubscriber: {
    type: 'Object'
  },
  startDate: {
    type: 'Date'
  },
  status: {
    type: 'Option',
    values: EInsuranceStatus
  },
  subscriber: {
    type: 'Object'
  },
  url: {
    type: 'Text'
  },
  urlBack: {
    type: 'Text'
  },
  verification: {
    type: 'Object'
  }
});